<panel *ngIf="!selected.discount && (!loading || !partners.empty)">
  <div header>
    <span [ngClass]="{'pointer text-primary': selected.partner}" (click)="select(null)">{{'Đơn trừ lỗi' | lang}} ({{configs.invoiceResolvableDays}} {{'ngày' | lang}})</span>
    <span *ngIf="selected.partner"><span class="hlf-margin-left hlf-margin-right">|</span>{{selected.partner.Name}}</span>
  </div>

  <div right class="flex">
    <text-filter *ngIf="!selected.partner" [target]="partners" [placeholder]="'Tìm khách hàng'"></text-filter>
    <text-filter *ngIf="selected.partner" [target]="discounts" [placeholder]="'Tìm đơn trừ'"></text-filter>
    <button *ngIf="selected.partner && selected.partner.ID > 0" class="pointer bg-danger text-white hlf-margin-left" (click)="create()"><i class="fa fa-plus"></i></button>
  </div>

  <table responsive class="data hover" *ngIf="!selected.partner">
    <tr>
      <th priority="6" class="text-top text-right" style="width: 0">{{'STT' | lang}}</th>
      <th priority="1"><sortable [target]="partners" [extractor]="partnerExtractor('Name')" [selected]="all.ConfirmedCount + all.EditableCount < 1">{{'Khách hàng' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="partners" [extractor]="partnerExtractor('ConfirmedCount')" [selected]="all.ConfirmedCount > 0 && all.EditableCount < 1" [sort]="'descending'">{{'Đơn xong' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="partners" [extractor]="partnerExtractor('EditableCount')" [selected]="all.EditableCount > 0" [sort]="'descending'">{{'Đơn chờ' | lang}}</sortable></th>      
      <th priority="5" class="text-right"><sortable [target]="partners" [extractor]="partnerExtractor('ImportDiscountAmount')">{{'Trừ NCC' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="partners" [extractor]="partnerExtractor('ExportDiscountAmount')">{{'Trừ cho khách' | lang}}</sortable></th>
      <th priority="2" style="width: 0"></th>
    </tr>

    <tr *ngFor="let i of partners.pageMatches; index as ix" class="pointer">
      <td (click)="select(i)"><small>{{ix + 1 + partners.pageIndex * partners.pageSize}}</small></td>
      <td (click)="select(i)">
        <div class="bold uppercase text-primary">{{i.Name}}</div>
        <small class="spacy">K{{i.ID}}</small>
      </td>
      <td (click)="select(i)">
        <b class="text-success">{{i.ConfirmedCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'đơn' | lang}}</unit>
      </td>
      <td (click)="select(i)">
        <b class="text-warning">{{i.EditableCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'đơn' | lang}}</unit>
      </td>
      <td (click)="select(i)">
        <div *ngIf="i.ImportDiscountVndAmount > 0">{{i.ImportDiscountVndAmount | number : '1.0-0' : 'en-US'}}<vnd></vnd></div>
        <div>{{i.ImportDiscountCnyAmount | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
      <td (click)="select(i)">
        <div>{{i.ExportDiscountVndAmount | number : '1.0-0' : 'en-US'}}<vnd></vnd></div>
        <div *ngIf="i.ExportDiscountCnyAmount > 0">{{i.ExportDiscountCnyAmount | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
      <td (click)="select(i); create()"><i class="text-danger fa fa-plus std-margin-left std-margin-right"></i></td>
    </tr>

    <tr *ngIf="partners.pages.length > 1" [ngClass]="{'footer': all.ConfirmedCount + all.EditableCount < 1 || partners.matches.length < partners.source.length}">
      <td style="display: none">></td>
      <td [colSpan]="7" class="text-center" style="z-index: unset"><pagination [target]="partners"></pagination></td>
    </tr>

    <tr class="footer text-primary pointer" (click)="select(all)" *ngIf="all.ConfirmedCount + all.EditableCount > 0 && partners.matches.length == partners.source.length">
      <td class="text-middle"><i class="fa fa-info-circle"></i></td>
      <td>
        <div class="bold uppercase text-primary">{{all.Name}}</div>
      </td>
      <td><b>{{all.ConfirmedCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'đơn' | lang}}</unit></td>
      <td><b>{{all.EditableCount | number : '1.0-0' : 'en-US'}}</b><unit>{{'đơn' | lang}}</unit></td>
      <td>
        <div *ngIf="all.ImportDiscountVndAmount > 0">{{all.ImportDiscountVndAmount | number : '1.0-0' : 'en-US'}}<vnd></vnd></div>
        <div>{{all.ImportDiscountCnyAmount | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
      <td>
        <div>{{all.ExportDiscountVndAmount | number : '1.0-0' : 'en-US'}}<vnd></vnd></div>
        <div *ngIf="all.ExportDiscountCnyAmount > 0">{{all.ExportDiscountCnyAmount | number : '1.1-1' : 'en-US'}}<cny></cny></div>
      </td>
      <td></td>
    </tr>

  </table>

  <table responsive class="data hover" *ngIf="selected.partner">
    <tr>
      <th class="text-left nowrap"><sortable [target]="discounts" [extractor]="extractor('Stamp')">{{'Ngày' | lang}}</sortable></th>
      <th class="text-center nowrap"><sortable [target]="discounts" [extractor]="extractor('Vendor')">{{'Nguồn hàng' | lang}}</sortable></th>
      <th class="text-center nowrap"><sortable [target]="discounts" [extractor]="extractor('Partner')">{{'Khách hàng' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="discounts" [extractor]="extractor('State')">{{'Trạng thái' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="discounts" [extractor]="extractor('SKUCount')">{{'Mặt hàng' | lang}}</sortable></th>
      <th class="text-center"><sortable [target]="discounts" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="discounts" [extractor]="extractor('ImportDiscountAmount')">{{'Trừ NCC' | lang}}</sortable></th>
      <th class="text-right"><sortable [target]="discounts" [extractor]="extractor('ExportDiscountAmount')">{{'Trừ cho khách' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of discounts.matches" class="pointer" (click)="open(i)">
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="bold nowrap text-warning">{{vendor(i).Name}}</td>
      <td class="bold nowrap text-primary">{{partner(i).Name}}</td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i) | lang}}</td>
      <td>{{distinct(i.Details, 'SKU').length | number : '1.0-0' : 'en-US'}}</td>
      <td>{{i.Details.length | number : '1.0-0' : 'en-US'}}</td>
      <td><b class="text-success">{{i.ImportDiscountAmount | number : '1.0-1' : 'en-US'}}</b><unit>{{i.ImportDiscountIcon}}</unit></td>
      <td><b class="text-warning">{{i.ExportDiscountAmount | number : '1.0-1' : 'en-US'}}</b><unit>{{i.ExportDiscountIcon}}</unit></td>
    </tr>
    <tr class="footer" *ngIf="discounts.pages.length > 1">
      <td [colSpan]="8" class="text-center" style="display: table-cell !important"><pagination [target]="discounts"></pagination></td>
    </tr>
  </table>

</panel>

<div class="editor" *ngIf="selected.discount">

  <div class="scrollable-x" #scrollableX>

    <div class="flex row">

      <panel [header]="false">

        <div class="flex col">

          <div class="flex space-between nowrap header items-center">
            <div class="bold uppercase std-margin-right">{{selected.discount.ID < 1 ? ('Tạo đơn trừ hàng lỗi mới' | lang) : ('Chỉnh sửa đơn trừ hàng lỗi' | lang)}} <span *ngIf="selected.vendor">{{ 'từ' | lang}} {{vendor(selected.discount).Name}}</span> {{'cho' | lang}} {{partner(selected.discount).Name}} (<span class="text-primary pointer" (click)="edit()">{{selected.discount.Stamp | date : 'dd-MM-yyyy'}}</span>)</div>
            <small *ngIf="selected.discount.ID > 0" class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row">

            <div class="scrollable" #scrollableLeft>

              <table responsive class="data" *ngIf="selected.details.length > 0">
                <tr>
                  <th class="text-top text-center">{{'Mã hàng' | lang}}</th>
                  <th class="text-top text-center">{{'Màu' | lang}}</th>
                  <th class="text-top text-right">{{'Giá nhập' | lang}}</th>
                  <th class="text-top text-right">{{'Giá xuất' | lang}}</th>
                  <th class="text-top text-center">{{'Dài / nặng' | lang}}</th>
                  <th class="text-top text-center">{{'Trừ' | lang}}</th>
                  <th class="text-top text-right">{{'Tính tiền' | lang}}</th>
                  <th class="text-top text-right">{{'Trừ NCC' | lang}}</th>
                  <th class="text-top text-right">{{'Trừ cho khách' | lang}}</th>
                  <th class="text-top text-right">{{'Tổng trừ NCC' | lang}}</th>
                  <th class="text-top text-right">{{'Tổng trừ cho khách' | lang}}</th>
                  <th class="text-top text-right" *ngIf="editable"></th>
                </tr>

                <ng-container *ngFor="let i of selected.details">
                  <tr *ngFor="let o of i.records; index as io">

                    <td><good class="bold spacy nowrap" *ngIf="io < 1" [sku]="i.SKU"></good></td>
                    <td class="bold">{{io < 1 ? i.Color : ''}}</td>
                    <td>
                      <div *ngIf="io < 1" class="nowrap">
                        {{i.ImportUnitPrice | number : '1.0-1' : 'en-US'}}
                        <symbol-per-unit [symbol]="selected.discount.ImportDiscountIcon" [type]="i.Unit"></symbol-per-unit>
                      </div>
                    </td>
                    <td>
                      <div *ngIf="io < 1" class="nowrap">
                        {{i.ExportUnitPrice | number : '1.0-1' : 'en-US'}}
                        <symbol-per-unit [symbol]="selected.discount.ExportDiscountIcon" [type]="i.Unit"></symbol-per-unit>
                      </div>
                    </td>
                    <td class="nowrap">
                      {{o.ActualQuantity | number : '1.1-1' : 'en-US'}}
                      <product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td class="nowrap">
                      {{o.ActualQuantity - o.ExportQuoteQuantity | number : '1.1-1' : 'en-US'}}
                      <product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td class="nowrap">
                      {{o.ExportQuoteQuantity | number : '1.1-1' : 'en-US'}}
                      <product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td>
                      <number-input class="bold" [ngClass]="{'text-danger': o.ImportDiscountQuantity + o.ExportDiscountQuantity <= 0, 'text-info': o.ImportDiscountQuantity + o.ExportDiscountQuantity > 0}" [allowNegative]="0" [fit]="true" [value]="o.ImportDiscountQuantity" (change)="setLength(o,'import',$event.target)" [decimalPlaces]="1"></number-input>
                      <product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td>
                      <number-input class="bold" [ngClass]="{'text-danger': o.ImportDiscountQuantity + o.ExportDiscountQuantity <= 0, 'text-info': o.ImportDiscountQuantity + o.ExportDiscountQuantity > 0}" [allowNegative]="0" [fit]="true" [value]="o.ExportDiscountQuantity" (change)="setLength(o,'export',$event.target)" [decimalPlaces]="1"></number-input>
                      <product-unit [type]="i.Unit"></product-unit>
                    </td>
                    <td>
                      <b class="text-success">{{o.ImportUnitPrice * o.ImportDiscountQuantity | number : '1.0-1' : 'en-US'}}</b>
                      <unit>{{selected.discount.ImportDiscountIcon}}</unit>
                    </td>
                    <td>
                      <b class="text-warning">{{o.ExportUnitPrice * o.ExportDiscountQuantity | number : '1.0-1' : 'en-US'}}</b>
                      <unit>{{selected.discount.ExportDiscountIcon}}</unit>
                    </td>
                    <td *ngIf="editable"><i class="fa fa-times pointer text-danger" (click)="remove([o])"></i></td>
                  </tr>
                </ng-container>
                <tr class="footer text-primary" *ngIf="!empty">
                  <td class="bold uppercase nowrap">{{'Tổng đơn' | lang}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="nowrap">
                    <b>{{statistics('ActualQuantity') | number : '1.1-1' : 'en-US'}}</b>
                    <m *ngIf="lengthCount > 0 && weightCount < 1"></m>
                    <kg *ngIf="weightCount > 0 && lengthCount < 1"></kg>
                    <unit *ngIf="lengthCount > 0 && weightCount > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{statistics('ActualQuantity') - statistics('ExportQuoteQuantity') | number : '1.0-2' : 'en-US'}}</b>
                    <m *ngIf="lengthCount > 0 && weightCount < 1"></m>
                    <kg *ngIf="weightCount > 0 && lengthCount < 1"></kg>
                    <unit *ngIf="lengthCount > 0 && weightCount > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{statistics('ExportQuoteQuantity') | number : '1.0-2' : 'en-US'}}</b>
                    <m *ngIf="lengthCount > 0 && weightCount < 1"></m>
                    <kg *ngIf="weightCount > 0 && lengthCount < 1"></kg>
                    <unit *ngIf="lengthCount > 0 && weightCount > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{statistics('ImportDiscountQuantity') | number : '1.0-2' : 'en-US'}}</b>
                    <m *ngIf="lengthCount > 0 && weightCount < 1"></m>
                    <kg *ngIf="weightCount > 0 && lengthCount < 1"></kg>
                    <unit *ngIf="lengthCount > 0 && weightCount > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td class="nowrap">
                    <b>{{statistics('ExportDiscountQuantity') | number : '1.0-2' : 'en-US'}}</b>
                    <m *ngIf="lengthCount > 0 && weightCount < 1"></m>
                    <kg *ngIf="weightCount > 0 && lengthCount < 1"></kg>
                    <unit *ngIf="lengthCount > 0 && weightCount > 0">{{'đv' | lang}}</unit>
                  </td>
                  <td><b>{{statistics('ImportDiscountAmount') | number : '1.0-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{selected.discount.ImportDiscountIcon}}</span></td>
                  <td><b>{{statistics('ExportDiscountAmount') | number : '1.0-2' : 'en-US'}}</b><span class="opacity-75 hlf-margin-left">{{selected.discount.ExportDiscountIcon}}</span></td>
                  <td *ngIf="editable"></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex">
            <button *ngIf="savable" class="bg-primary text-white" (click)="save()"><span>{{(selected.discount.ID > 0 ? 'Cập nhập đơn trừ hàng lỗi' : 'Tạo đơn trừ hàng lỗi') | lang}}</span></button>
            <button *ngIf="confirmable" class="bg-danger text-white" (click)="confirm()"><span>{{'Xác nhận đơn trừ hàng lỗi' | lang}}</span></button>
            <button *ngIf="cancelable" class="bg-success text-white" (click)="cancel()"><span>{{'Hủy đơn trừ hầng lỗi' | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel [header]="false" *ngIf="!selected.vendor || !goods.empty">

        <div class="flex col">

          <div class="flex space-between items-center header">
            <div class="uppercase bold nowrap std-margin-right" *ngIf="selected.details.length < 1 && vendors.source.length > 1">
              <span [ngClass]="{'pointer text-primary': selected.vendor}" (click)="toggle(null)">{{'Tất cả nguồn hàng' | lang}} ({{selected.partner.Name}})</span>
              <span *ngIf="selected.vendor"><span class="hlf-margin-left hlf-margin-right">|</span>{{selected.vendor.Name}}</span>
            </div>
            <text-filter [ngClass]="{'flex-grow-1': selected.details.length > 0 || vendors.source.length < 2}" [target]="goods" *ngIf="selected.vendor" [placeholder]="'Tìm mã hàng'"></text-filter>
          </div>

          <div class="flex row">
            <div class="scrollable" #scrollableRight>

              <ng-container *ngIf="!selected.discount">

                <div *ngFor="let i of partners.matches" (click)="toggle(i)" [ngClass]="{'active': i == selected.partner}">
                  <icon-text [icon]="'fa fa-user-tie'">
                    <b>{{i.Name}}</b>
                    <br />
                    <small class="uppercase bold">{{i.Phone}}</small>

                  </icon-text>
                </div>
              </ng-container>


              <table responsive class="data hover" *ngIf="!selected.vendor">
                <tr>
                  <th class="text-top">{{'NCC' | lang}}</th>
                  <th class="text-top text-right">{{'Hàng mét' | lang}}</th>
                  <th class="text-top text-right">{{'Hàng cân' | lang}}</th>
                </tr>
                <tr *ngFor="let i of vendors.pageMatches" class="pointer" (click)="toggle(i)">
                  <td>
                    <div class="bold uppercase nowrap text-primary">{{i.Name}}</div>
                    <small class="uppercase spacy">K{{i.ID}}</small>
                  </td>
                  <td>
                    <div>{{i.LengthQuantity | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <small>{{i.LengthCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
                  </td>
                  <td>
                    <div>{{i.WeightQuantity | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <small>{{i.WeightCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></small>
                  </td>
                </tr>
              </table>

              <table class="data hover" *ngIf="selected.vendor">
                <tr>
                  <th class="text-left">Mã hàng</th>
                  <th class="text-center">Màu</th>
                  <th class="text-center">Dài / nặng</th>
                  <th class="text-right">Giá</th>
                  <th class="text-right">Nguồn</th>
                </tr>
                <tr *ngFor="let i of goods.pageMatches" (click)="add(i)">
                  <td class="text-left">
                    <good class="bold spacy nowrap" [sku]="i.SKU"></good>
                  </td>
                  <td class="text-center bold text-info">{{i.Color}}</td>
                  <td class="text-center nowrap">
                    {{i.ActualQuantity | number : '1.0-1' : 'en-US'}}
                    <product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td class="text-right nowrap">
                    <b class="text-success">{{i.ExportUnitPrice | number : '1.0-0' : 'en-US'}}</b>
                    <symbol-per-unit [symbol]="i.ExportSymbol" [type]="i.Unit"></symbol-per-unit>
                    <div class="small text-danger">
                      {{i.ImportUnitPrice | number : '1.0-2' : 'en-US'}}
                      <symbol-per-unit [symbol]="i.ImportSymbol" [type]="i.Unit"></symbol-per-unit>
                    </div>
                  </td>
                  <td class="text-right nowrap">
                    <div class="small spacy">{{i.ImportInvoiceTag}}</div>
                    <small>{{source(i.ImportInvoiceTag)}}</small>
                  </td>
                </tr>
                <tr class="footer" *ngIf="goods.pages.length > 1">
                  <td [colSpan]="6" class="text-center"><pagination [target]="goods"></pagination></td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableRight"></scrollbar>
          </div>
        </div>
      </panel>

    </div>

  </div>

  <scrollbar [target]="scrollableX" class="bottom"></scrollbar>
</div>


<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
